import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import planReducer from './reducers/planReducer';
import enrollmentReducer from './slices/enrollmentSlice';
import reportReducer from './slices/reportSlice';
import dashboardReducer from './reducers/dashboardReducer';
import s3Reducer from './slices/s3Slice';
import censusReducer from './slices/censusSlice';

export const store = configureStore({
    reducer: {
        plan: planReducer,
        enrollment: enrollmentReducer,
        reports: reportReducer,
        dashboard: dashboardReducer,
        s3: s3Reducer,
        census: censusReducer
    }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();